import { Observable, observe, Scope } from 'wdc-cube'
import { FaixaRatingRow, GrupoAnaliseRow, GrupoRow } from '../grupo.types'

@Observable
export class GrupoFormScope extends Scope {
    @observe() idSelected = 0 as number
    @observe() idAnaliseSelected = 0 as number

    @observe() tipo = 'BORDERO' as string
    @observe() nome = '' as string
    @observe() status = 'ATIVO' as string
    @observe() rating1Start = 0 as number
    @observe() rating2Start = 0 as number

    @observe() faixasRating1 = [] as FaixaRatingRow[]
    @observe() faixasRating2 = [] as FaixaRatingRow[]
    @observe() analises = [] as GrupoAnaliseRow[]

    @observe() editingFaixaRating1Id = undefined as number | undefined
    @observe() editingFaixaRating1Tipo = 'RATING_1'
    @observe() editingFaixaRating1FaixaInicial = 0
    @observe() editingFaixaRating1FaixaFinal = 0
    @observe() editingFaixaRating1Sigla = ''
    @observe() editingFaixaRating1Descricao = ''
    @observe() editingFaixaRating1MostrarRating = true

    @observe() editingFaixaRating2Id = undefined as number | undefined
    @observe() editingFaixaRating2Tipo = 'RATING_2'
    @observe() editingFaixaRating2FaixaInicial = 0
    @observe() editingFaixaRating2FaixaFinal = 0
    @observe() editingFaixaRating2Sigla = ''
    @observe() editingFaixaRating2Descricao = ''
    @observe() editingFaixaRating2MostrarRating = true

    onSave = async (): Promise<GrupoRow | undefined> => undefined
    onClose = Scope.ASYNC_ACTION

    onSaveFaixaRating1 = Scope.ASYNC_ACTION
    onClearFaixaRating1 = Scope.ASYNC_ACTION
    onEditFaixaRating1 = Scope.ASYNC_ACTION_NUMBER

    onSaveFaixaRating2 = Scope.ASYNC_ACTION
    onEditFaixaRating2 = Scope.ASYNC_ACTION_NUMBER
    onClearFaixaRating2 = Scope.ASYNC_ACTION

    onDeleteFaixaRating = Scope.ASYNC_ACTION_NUMBER

    onCreateAnalise = Scope.ASYNC_ACTION
    onAddAnalise = Scope.ASYNC_ACTION
    onEditAnalise = Scope.ASYNC_ACTION
    onDeleteAnalise = Scope.ASYNC_ACTION
}

export default GrupoFormScope
